import { IModifier } from './Modifier';
import { EAnimationModifiers } from '../../Animation/SpineWrapperEventManager';
import { getAllEventModifiers } from '../../Utils/ModifierUtils';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { GameStore } from '@GameStore/GameStore';

export class WallMultiplierModifier implements IModifier {
    constructor(readonly gameStore: GameStore) {}

    public modifierCheck(name: string): boolean {
        return !!this.getWallMultiplierFromName(getAllEventModifiers(name));
    }

    public requirementCheck(name: string): boolean {
        const step = this.gameStore.get(EGameStoreKeys.SpinOutcome).steps?.at(-1);
        if (!step) return false;
        const wallMultiplier = step.wallMultiplier;
        const nameModifiers = getAllEventModifiers(name);
        const wallMultiplierFromName = this.getWallMultiplierFromName(nameModifiers);
        const canPlay = wallMultiplierFromName === wallMultiplier;
        return canPlay;
    }

    private getWallMultiplierFromName(nameParams: string[]): number | undefined {
        const modifier = nameParams.find((param) => param.includes(EAnimationModifiers.WALL_MULTIPLIER));
        if (!modifier) return;
        const match = new RegExp(/\d+/).exec(modifier);
        if (!match) return;
        const num = Number.parseInt(match[0], 10);
        return num;
    }
}
